// extracted by mini-css-extract-plugin
export default {"noPageFoundPage":"NoPageFoundPage_noPageFoundPage__jdYGg","noPageFoundPage__errorMessage":"NoPageFoundPage_noPageFoundPage__errorMessage__tlubd"};